<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="title-confirm-cancel">{{ 'confirmCancellation.title' | translate }}</h2>
    <section class="infoBox" *ngIf="!showCancelBox">
        <p id="info-confirm-cancel">{{ 'confirmCancellation.description' | translate:{onHoldAvailability: onHoldAvailability} }}
            <app-wl-electronic-signature-purpose class="right"></app-wl-electronic-signature-purpose>
        </p>
    </section>

    <section *ngIf="!showCancelBox">
        <div class="centeredContainer">
            <div>
                <fieldset id="gallery" class="row">
                    <div class="{{onHoldAvailability && !onHoldLimitReached?'one-column-three':'one-column-two'}}">
                        <div class="content cancel-content-left">
                            <div class="cancel-content-text">
                                <p id="continue-text">{{ 'confirmCancellation.return.text' | translate }}</p>
                            </div>
                            <div class="cancel-content-button"><span class="centeredContainer"> <a id="resume-link"
                                                                                                   (click)="goTo('continue')"
                                                                                                   class="k-button k-button-primary floatNone">{{
                                'confirmCancellation.return' | translate }}</a>
                                 </span></div>
                        </div>
                    </div>
                    <div *ngIf="onHoldAvailability && !onHoldLimitReached" class="one-column-three">
                        <div class="content cancel-content-center">
                            <div class="cancel-content-text">
                                <p id="hold-text">{{ 'confirmCancellation.hold.text' | translate }}</p>
                            </div>
                            <div class="cancel-content-button"><span class="centeredContainer"> <a id="hold-link"
                                                                                                   (click)="goTo('hold')"
                                                                                                   class="k-button k-button-primary floatNone">{{
                                'confirmCancellation.hold' | translate }}</a>
                                 </span></div>
                        </div>
                    </div>
                    <div class="last-column {{onHoldAvailability && !onHoldLimitReached?'one-column-three':'one-column-two'}}">
                        <div class="content cancel-content-right content-bo">
                            <div class="cancel-content-text">
                                <p id="confirm-text">{{ 'confirmCancellation.confirm.text' | translate }}</p>
                            </div>
                            <div class="cancel-content-button"><span class="centeredContainer"> <a id="discontinue-link"
                                                                                                   data-(click)="goTo('cancel')"
                                                                                                   class="k-button floatNone">{{
                                'confirmCancellation.confirm' | translate }}</a>
                                </span></div>
                        </div>
                    </div>

                </fieldset>
            </div>
        </div>
    </section>
    <section *ngIf="showCancelBox" class="infoBox">
        <div class="centeredContainer">
            <form name="form" [formGroup]="formValidation">
                <div class="reasonBox" *ngIf="!nothingRequired">
                    <label>
                        <span class="required" id="cancel-reason-select">{{ 'cancellation.reason.select' | translate }}</span> :
                        <select *ngIf="specificRequired" class="reasonSelect" [(ngModel)]="specificData.model" name="reason" formControlName="reason">
                            <option *ngFor="let reason of specificData.reasons" value="{{reason}}">{{ reason | translate }}</option>
                            <option value="" disabled="disabled">{{ 'cancellation.reason.default' | translate }}</option>
                        </select>
                        <div [hidden]="!formValidation.controls['reason'].invalid" role="alert">
                            <div [hidden]="!(formValidation.controls['reason'].errors && formValidation.controls['reason'].errors!['required'])"
                                 id="cancel-reason-required">
                                <span class="fa fa-exclamation-circle" aria-hidden="true"></span>
                                {{ 'cancellation.reason.required' | translate }}
                            </div>
                        </div>
                    </label>
                    <div *ngIf="specificData?.model === 'cancel.reason.alternativeway'">
                        <label data-translate="confirmCancellation.alternateway.text" data-translate-compile></label>
                    </div>
                    <div *ngIf="customRequired && !(specificData?.model === 'cancel.reason.alternativeway')">
                        <label>
                            <span class="required" id="custom-cancel-message">{{ 'cancellation.reason.details' | translate }}</span> :
                            <textarea id="custom-cancel-textarea"
                                      class="reasonDetail"
                                      [(ngModel)]="detail"
                                      formControlName="detail"
                                      name="detail">
                            </textarea>
                            <div [hidden]="!(formValidation.controls['detail'].invalid)" role="alert">
                                <div id="custom-cancel-reason-required"
                                     [hidden]="!(formValidation.controls['detail'].errors && formValidation.controls['detail'].errors!['required'])"><span
                                        class="fa fa-exclamation-circle"
                                        aria-hidden="true"></span> {{
                                    'cancellation.reason.required' | translate }}
                                </div>
                                <div [hidden]="!(formValidation.controls['detail'].errors && (formValidation.controls['detail'].errors!['maxlength'] || formValidation.controls['detail'].errors!['minlength']))"><span
                                        class="fa fa-exclamation-circle"
                                        aria-hidden="true"></span>
                                    {{remaining() * (-1)}} {{ 'cancellation.reason.detail.oversize' | translate }}
                                </div>
                            </div>
                        </label>
                        <div *ngIf="remaining() >= 0">{{remaining()}} {{ 'cancellation.reason.detail.left' | translate }}</div>
                    </div>
                </div>

                <p *ngIf="errorMsg" class="error-form">{{ errorMsg | translate }}</p>

                <span class="centeredContainer">
                    <a id="confirm-cancel-link"
                       (click)="cancel(formValidation)" class="k-button floatNone"
                       [attr.disabled]="!canCancel() ? 'disabled' : null">
                        {{'confirmCancellation.confirm.discontinuation' | translate }}</a>
                </span>
            </form>
        </div>
        <p class="back-link">
            <span id="cancel-cancel" (click)="goTo('all')">{{'evidences.cancel' | translate }}</span>
        </p>
    </section>

</main>